import { z } from 'zod'

const EnvelopeErrorDescription = z.object({
  message: z.string(),
  code: z.string(),
})

export type EnvelopeErrorDescription = z.infer<typeof EnvelopeErrorDescription>

/**
 * traceId - Unique identifier for tracing the request. Can be an AWS request ID.
 */
export const ResponseEnvelope = z.discriminatedUnion('status', [
  z.object({
    status: z.literal('success'),
    traceId: z.string().optional(),
    data: z.unknown(),
  }),
  z.object({
    status: z.literal('error'),
    traceId: z.string().optional(),
    error: EnvelopeErrorDescription,
  }),
])

export type ResponseEnvelope = z.infer<typeof ResponseEnvelope>
